import { useEffect, useState } from 'react';
import { useLaMevaLlista } from 'hooks/3catinfo/useLaMevaLlista';
import { useUser } from 'hooks/useUser';
import Slider from 'components/3catinfo/Slider';
import Boto from 'components/3catinfo/Boto';
import Fila from 'components/3catinfo/Fila';
import Destacat from 'components/3catinfo/Destacat';
import MostraMes from 'components/3catinfo/MostraMes';
import __isEmpty from 'lodash/isEmpty';
import __isArray from 'lodash/isArray';
import useIsServiceEnabled from 'hooks/useIsServiceEnabled';
import styles from './blocareausuaris.module.scss';
import clsx from 'clsx';

const BlocNoticies = (props) => {
    const { items, isLoading, isSpmEnabled } = props;
    const { isAuthenticated } = useUser();

    const stylesBlocNoticies = clsx({
        [styles.blocAreaUsuaris]: true,
        [styles.authenticatedAmbItems]: true
    });

    if (!isSpmEnabled || !isAuthenticated || __isEmpty(items)) return <></>;

    return (
        <div className={stylesBlocNoticies} data-testid='areausuaris'>
            {isLoading ? (
                <div>Carregant...</div>
            ) : (
                <>
                    <Slider className='noticiesguardades' titol='Notícies guardades' titolClass='secundari' format='meu3cat'>
                        {items?.slice(0, 4).map((item, index) => (
                            <Destacat
                                key={`destacat-autor-${item.id}`}
                                format='basic'
                                className='noGapAfter'
                                tipusImatge='web_slider'
                                item={item}
                                index={index + 1}
                                mostraAfegirBookmark={true}
                            />
                        ))}
                    </Slider>
                </>
            )}
        </div>
    );
};

const BlocTemes = (props) => {
    const { items, isLoading, isSpmEnabled } = props;
    const { isAuthenticated } = useUser();
    const totalItems = items.length;

    const stylesBlocNoticies = clsx({
        [styles.blocAreaUsuaris]: true,
        [styles.authenticatedAmbItems]: true
    });

    if (!isSpmEnabled || !isAuthenticated || __isEmpty(items)) return <></>;

    return (
        <div className={stylesBlocNoticies} data-testid='areausuaris'>
            {isLoading ? (
                <div>Carregant...</div>
            ) : (
                <>
                    <Fila columnes='6_6' tipus='fixed'>
                        {totalItems > 0 && <Destacat format='basic' numColumnsRow={6} item={items[0]} />}
                        <div>
                            <Fila columnes='3_3' tipus='fluid'>
                                {totalItems > 1 && (
                                    <Destacat numColumnsRow={3} format='basic' item={items[1]} formatMobile={'horitzontal'} />
                                )}
                                {totalItems > 2 && (
                                    <Destacat numColumnsRow={3} format='basic' item={items[2]} formatMobile={'horitzontal'} />
                                )}
                            </Fila>
                            <Fila columnes='3_3' tipus='fluid'>
                                {totalItems > 3 && (
                                    <Destacat numColumnsRow={3} format='basic' item={items[3]} formatMobile={'horitzontal'} />
                                )}
                                {totalItems > 4 && (
                                    <Destacat numColumnsRow={3} format='basic' item={items[4]} formatMobile={'horitzontal'} />
                                )}
                            </Fila>
                        </div>
                    </Fila>
                </>
            )}
        </div>
    );
};

const PersonalitzaEspai = (props) => {
    const { items, linies, isSpmEnabled } = props;
    const { isAuthenticated, name } = useUser();

    if (isSpmEnabled && isAuthenticated && __isEmpty(items.temesAndFirmes) && !__isEmpty(items.noticies))
        return (
            <Fila columnes='12' tipus='fixed'>
                {__isEmpty(items.temesAndFirmes) && !__isEmpty(items.noticies) && (
                    <div className={styles.blocNoSegueixes}>
                        <p>Encara no segueixes cap tema ni firma.</p>
                        <Boto
                            text='Comença ara'
                            altIcona='Comença ara'
                            estil='lined'
                            dataTestId='areausuaris-comenca-ara'
                            route={{ type: 'web_3catinfo_meu3catinfo' }}
                            className={styles.boto}
                        />
                    </div>
                )}
            </Fila>
        );

    if (!isSpmEnabled || !isAuthenticated || !__isEmpty(items.temesAndFirmes) || !__isEmpty(items.noticies)) return <></>;

    return (
        <Fila columnes='12' tipus='fixed'>
            <div className={styles.blocAreaUsuaris} data-testid='areausuaris'>
                <div className={styles.infoWrapper}>
                    <h3 className={styles.title} data-testid='areausuaris-titol'>
                        {name}, fes-te l&#39;actualitat a mida
                    </h3>
                    <ul className={styles.llistaPunts}>
                        {linies.map((item, index) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                    <div className={styles.buttons}>
                        <Boto
                            text='Comença ara'
                            altIcona='Comença ara'
                            estil='iniciaSessio'
                            dataTestId='areausuaris-comenca-ara'
                            route={{ type: 'web_3catinfo_meu3catinfo' }}
                            className={styles.boto}
                        />
                    </div>
                </div>
            </div>
        </Fila>
    );
};

const IniciaSessio = (props) => {
    const { titol, linies, isSpmEnabled } = props;
    const { isAuthenticated, signIn, signUp } = useUser();

    if (isAuthenticated) return <></>;

    return (
        <Fila columnes='12' tipus='fixed'>
            <div className={styles.blocAreaUsuaris} data-testid='areausuaris'>
                <div className={styles.infoWrapper}>
                    <h3 className={styles.title} data-testid='areausuaris-titol'>
                        {titol}
                    </h3>
                    <ul className={styles.llistaPunts}>
                        {linies.map((item, index) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                    {isSpmEnabled && (
                        <div className={styles.buttons}>
                            <Boto
                                tag='button'
                                text='Inicia sessió'
                                altIcona='Inicia sessió'
                                estil='iniciaSessio'
                                dataTestId='areausuaris-inicia-sessio'
                                onClick={() => signUp()}
                            />
                            <Boto
                                tag='button'
                                text='Crea el teu compte 3Cat'
                                estil='lined'
                                tema='secondary'
                                iconaInline={true}
                                altIcona='Crea el teu compte 3Cat'
                                dataTestId='areausuaris-crea-compte'
                                onClick={() => signIn()}
                            />
                        </div>
                    )}
                </div>
            </div>
        </Fila>
    );
};

const BlocAreaUsuaris = (props) => {
    const { titol, linies, imgMobile, imgDesktop, botoMostraMes } = props;

    const { isAuthenticated, accessToken } = useUser();

    const isVrEnabled = useIsServiceEnabled('videos-recomanats');
    const isRmEnabled = useIsServiceEnabled('resume-media');
    const isSpmEnabled = isVrEnabled && isRmEnabled;

    const {
        itemsLaMevaLlista,
        getFullItemsFromApi,
        getFullItemsFromApiDtyCategory,
        getFullItemsFromApiNotAutor,
        getFullCategoriesInfo
    } = useLaMevaLlista();
    const [userItems, setUserItems] = useState({
        temesAndFirmes: [],
        noticies: []
    });

    const [isLoading, setIsLoading] = useState(true);

    const _getTemesAndFirmes = async () => {
        const page = 1;
        const numItems = 5;

        const parseDate = (dateStr) => {
            const [day, month, year, time] = dateStr.match(/(\d{2})\/(\d{2})\/(\d{4}) (.+)/).slice(1);
            return new Date(`${year}-${month}-${day}T${time}`);
        };

        const categoriesInfo = await getFullCategoriesInfo();
        const noticiesTemes = await getFullItemsFromApiDtyCategory(
            'DTY_CATEGORY',
            page,
            numItems,
            'TOTS',
            categoriesInfo?.blocsInfoCategories
        );

        const noticiesAutor = await getFullItemsFromApiNotAutor('NOT_AUTOR', page, numItems, 'TOTES');
        const mergedNoticiesAutorAndTemesAndFirmesUniq = [
            ...(noticiesTemes?.blocsInfoContingut || []),
            ...(noticiesAutor?.blocsInfoContingut || [])
        ]
            .reduce((map, item) => {
                map.set(item.id, item);
                return map;
            }, new Map())
            .values();
        const temesAndFirmes = Array.from(mergedNoticiesAutorAndTemesAndFirmesUniq).sort(
            (a, b) => parseDate(b.data_publicacio) - parseDate(a.data_publicacio)
        );

        return temesAndFirmes || [];
    };

    useEffect(() => {
        const isEmptyItemsLaMevaLlista = () => {
            if (__isArray(itemsLaMevaLlista) && __isEmpty(itemsLaMevaLlista[0])) {
                return true;
            } else if (typeof itemsLaMevaLlista === 'object' && __isEmpty(itemsLaMevaLlista)) {
                return true;
            } else {
                return false;
            }
        };

        const fetchData = async () => {
            const noticies = await getFullItemsFromApi(1, 4);
            const temesAndFirmes = await _getTemesAndFirmes();
            setUserItems({
                temesAndFirmes,
                noticies: noticies.blocsInfoContingut || []
            });
            setIsLoading(false);
        };

        if (isAuthenticated && !isEmptyItemsLaMevaLlista()) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, itemsLaMevaLlista]);

    return (
        <section
            aria-label='El meu 3CatInfo'
            className={styles.blocAreaUsuarisContainer}
            style={{
                '--bg-web': `url(${imgDesktop})`,
                '--bg-mobile': `url(${imgMobile})`
            }}
        >
            <PersonalitzaEspai items={userItems} linies={linies} isSpmEnabled={isSpmEnabled} />
            <div className={styles.itemsWrapper}>
                <BlocTemes
                    items={userItems.temesAndFirmes}
                    isLoading={isLoading}
                    titol='Temes i firmes'
                    icona='mes_contorn_cercle_bold'
                    mostraTematica={false}
                    isSpmEnabled={isSpmEnabled}
                />
                <BlocNoticies
                    items={userItems.noticies}
                    isLoading={isLoading}
                    titol='Notícies guardades'
                    mostraTematica={false}
                    isSpmEnabled={isSpmEnabled}
                />
            </div>
            {isAuthenticated && botoMostraMes && (
                <MostraMes
                    titol={botoMostraMes.titol}
                    titolTema='El meu 3CatInfo'
                    slug={botoMostraMes.slug}
                    linkTipus={botoMostraMes.linkTipus}
                    estil='mt-300'
                />
            )}
            <IniciaSessio titol={titol} linies={linies} isSpmEnabled={isSpmEnabled} />
        </section>
    );
};

export default BlocAreaUsuaris;
